module.exports = __webpack_public_path__ + "static/media/bulletin.d10d89b9.svg";